module.exports = __webpack_public_path__ + "media/images/btn_google_play_2x-f26cd135.png";